export default __webpack_public_path__ + "structdatac46ff4.png";